function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { urlAccountRegistration } from "scripts/constants/urls";
import showNotification from "scripts/dom_utils/notification";
import { qs } from "scripts/data_utils/domHelpers";
import { sendYaMetricksEvent } from "scripts/utils/sendYaMetricksEvent";
import { throwError } from "scripts/data_utils/throwError";
import emailValidation from "scripts/data_utils/email_validation";
import formDataFetch from "scripts/data_utils/formDataFetch";
import { getGlobal } from "scripts/utils/global";
import { logEvent } from "scripts/utils/amplitude";
import { setMessageInStore } from "scripts/utils/messagesInStore";
import PopupPrompt from "./popup_prompt";

function getQueryParams(queryString) {
  const queryStringWithSpaces = queryString.split("+").join(" ");
  const params = {};
  let tokens;
  const re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(queryStringWithSpaces)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

function getTargetName(elem) {
  let target = "very_old_browser";

  try {
    // eslint-disable-next-line prefer-destructuring
    target = elem.dataset.target;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }

  return target;
}

class RegistrationPopup extends PopupPrompt {
  constructor(el, values) {
    super(el);

    _defineProperty(this, "toggleUnMask", () => {
      const {
        passwordField
      } = this.fields;

      if (passwordField.type === "password") {
        passwordField.type = "text";
        this.unmask.classList.add("open");
      } else {
        passwordField.type = "password";
        this.unmask.classList.remove("open");
      }
    });

    _defineProperty(this, "validationForm", e => {
      e.preventDefault();

      if (!this.fields.emailField.value) {
        this.showFieldError(this.form, "email", "Введите e-mail");
        return;
      }

      if (!emailValidation(this.fields.emailField.value)) {
        this.showFieldError(this.form, "email", "Не похоже на e-mail");
        return;
      }

      if (!this.fields.passwordField.value) {
        this.showFieldError(this.form, "password", "Введите пароль", false);
        return;
      }

      this.sendForm();
    });

    _defineProperty(this, "sendForm", () => {
      const url = urlAccountRegistration;
      const queryParams = getQueryParams(location.search);
      const referral = queryParams.referral ? queryParams.referral : null;
      const data = {
        email: this.fields.emailField.value,
        password: this.fields.passwordField.value
      };

      if (referral !== null) {
        data.referral = referral;
      }

      this.disableSubmitButton();
      formDataFetch(url, data).then(response => {
        if (response.errors.length > 0) {
          this.showAllErrors(response.errors);
          this.enableSubmitButton();
        } else {
          this.hidePopup();
          showNotification({
            text: "Мы отправили вам письмо для подтверждения регистрации!",
            status: "success"
          });
          setMessageInStore({
            id: "register",
            type: "success",
            text: "Мы отправили вам письмо для подтверждения регистрации!"
          });
          const {
            result: {
              redirect_url: redirectUrl,
              tracking_id: trackingId
            }
          } = response;

          if (window.__ANALYTICS_ENABLE__) {
            var _getGlobal;

            (_getGlobal = getGlobal("dataLayer")) === null || _getGlobal === void 0 ? void 0 : _getGlobal.push({
              event: "PMuserRegOK",
              userId: trackingId
            });
            sendYaMetricksEvent("reg");

            if (window.location.pathname === '/ebukva/') {
              sendYaMetricksEvent("success_ebukva_registration_form", {
                email: this.fields.emailField.value
              });
            }

            logEvent("onbRegisterClick", {
              from: location.pathname,
              referral,
              place: this.targetName
            });
          }

          if (redirectUrl) {
            location.replace(redirectUrl);
          }
        }
      }).catch(error => {
        throwError({
          error
        });
        this.enableSubmitButton();
      });
    });

    _defineProperty(this, "body", `
  <div class="modal-wrapper__title">
    Регистрация
    <a href="/faq/first-step/#new-account"
    class="link link--small link--underline" target="_blank" rel="noreferrer noopener">
      Подробнее
    </a>
  </div>

  <form autocomplete="off" class="js-form" method="post">
    <label for="email" class="text-input">
      <span class="text-input__text">Ваша электронная почта</span>
      <input class="text-input__input js-email" type="email" autocomplete="nope" value=""/>
      <div class="modal-wrapper__error js-error-container form-error-email" style="display:none"></div>
    </label>

    <label for="password" class="text-input">
      <span class="text-input__text">Придумайте пароль</span>
      <span class="modal-wrapper__input-container">
        <input class="text-input__input js-password" autocomplete="new-password" type="password"/>
        <button class="modal-wrapper__unmask js-unmask" type="button"></button>
      </span>
      <div class="modal-wrapper__error js-error-container form-error-password" style="display:none"></div>
    </label>
    
    <div style="display: flex; flex-direction: column; margin-top: 5px;">
      <span class="modal-wrapper__description-label">Требования к паролю:</span>
      <ul class="modal-wrapper__description-items">
        <li>8 и более символов</li>
        <li>прописные и строчные буквы</li>
        <li>знак пунктуации и цифру</li>
      </ul>
    </div>

    <div style="display: flex; flex-direction: column; margin-top: 15px;">
      <button type="submit" class="button button--big button--primary js-submit">Зарегистрироваться</button>
      <button class="button button--big button--default js-show-login-popup">Войти</button>
    </div>
    
    <div>
      <div class="modal-wrapper__error js-error-container js-__all__ form-error-__all__" style="display:none"></div>
    </div>
    <div class="modal-wrapper__footer-link">
      При регистрации вы соглашаетесь <br>
      с <a href="/offer/" target="_blank" rel="noreferrer noopener" class="link link--underline">публичной офертой</a>.
    </div>
  </form>
  `);

    this.init();
    this.form = qs(".js-form", this.dialogBox);
    this.button = qs(".js-submit", this.form);
    this.loader = document.createElement("div");
    this.loader.classList.add("loader-round");
    this.targetName = getTargetName(el);
    this.fields = {
      emailField: qs(".js-email", this.form),
      passwordField: qs(".js-password", this.form)
    };
    this.unmask = qs(".js-unmask", this.form);
    this.fields.emailField.value = values.email;
    this.fields.passwordField.value = values.password;
    this.form.addEventListener("submit", this.validationForm);
    this.unmask.addEventListener("mousedown", this.toggleUnMask);
    this.hideErrorOnClickOnField();
  }

}

export default RegistrationPopup;